import { CellContext } from "@tanstack/react-table";
import { VariantWithProductData } from "../types";
import { setNameCellTestId } from "../products-table.utils";

const VariantIndent = () => <div className="text-xs text-muted-foreground pl-4">└─</div>;

interface NameCellProps {
  isFirstVariant?: boolean;
}

export const NameCellMarkup = (props: CellContext<VariantWithProductData, unknown> & NameCellProps) => {
  const data = props.row.original;
  const isFirstVariant = props.isFirstVariant ?? true;

  return (
    <div data-testid={setNameCellTestId(props.row.index)}>
      {isFirstVariant ? (
        <div className="flex flex-col">
          <span className="font-medium text-sm">{data.productTitle}</span>
          <span className="text-xs text-muted-foreground">{data.productSku}</span>
        </div>
      ) : (
        <VariantIndent />
      )}
    </div>
  );
};
